import { Component, OnInit } from '@angular/core';
import { CourseService, UserService } from 'src/app/_services/generatedServices';
import { CourseSearchParameters, CourseSearchResultsViewModel, CourseViewModel, CourseViewModelSimple, SearchFilterDataModel } from 'src/app/_models/generatedModels';

@Component({
  selector: 'bxl-library',
  templateUrl: 'library.component.html',
})
export class LibraryComponent implements OnInit {
  initialized = false;
  searching = false;
  resultCount: number;
  searchParams: CourseSearchParameters;
  courses: CourseViewModelSimple[];
  filterData: SearchFilterDataModel;
  constructor(private userService: UserService, private courseService: CourseService) {}

  ngOnInit(): void {
    this.searchParams = new CourseSearchParameters();
    this.searchParams.completedCEUs = null;
    this.searchParams.conferenceId = null;
    this.searchParams.watched = null;
    this.searchParams.tag = null;
    this.searchParams.certifyingBodyId = null;

    this.courseService.getFilterDataForUser().subscribe((result) => {
      this.filterData = result;
      this.search(true);
    });
  }

  search(resetPaging: boolean) {
    this.searching = true;
    if (resetPaging) {
      this.searchParams.page = 0;
    }
    this.userService.searchPurchasedCourses(this.searchParams).subscribe((result) => {
      this.courses = result.results;
      this.resultCount = result.rowCount;
      this.searchParams.pageSize = result.pageSize;
      this.searchParams.page = result.currentPage;
      this.initialized = true;
      this.searching = false;
      console.log(this.courses);
    });
  }

  paginate(event) {
    //event.first = Index of the first record
    //event.rows = Number of rows to display in new page
    //event.page = Index of the new page
    //event.pageCount = Total number of pages
    this.searchParams.page = event.page;
    this.searchParams.pageSize = event.rows;
    this.search(false);
  }
}
